var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1656577301323,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8363,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 135.9c10.6 0 20.9 0.9 31.1 2.5 1.6-4 2.6-8.3 2.6-12.8 0-18.6-15.1-33.6-33.6-33.6-18.6 0-33.6 15.1-33.6 33.6 0 4.5 0.9 8.9 2.6 12.8 10-1.6 20.3-2.5 30.9-2.5zM512 796.8H397.3c-1 6.2-1.7 12.4-1.7 18.9 0 64.3 52.1 116.4 116.4 116.4 64.3 0 116.4-52.1 116.4-116.4 0-6.4-0.7-12.7-1.7-18.9H512z",
    "p-id": 8364,
    fill: "#F93535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M804.1 688.9c-39.5 0-53.3-31.1-53.3-77.3 0-18.1-3.7-257.8-3.7-257.8 0-113.7-106-211.7-235.1-211.7s-235.1 98-235.1 211.7c0 0-3.7 239.6-3.7 257.8 0 46.2-13.8 77.3-53.3 77.3-37.8 0-57.1 17.3-57.1 49.4 0 27.2 25.7 49.4 57.1 49.4h584.2c31.4 0 57.1-22.2 57.1-49.4 0-32.1-19.3-49.4-57.1-49.4z",
    "p-id": 8365,
    fill: "#F93535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertime);
export default __webpack_public_path__ + "static/media/overtime.af8aae7e.svg";
export { ForwardRef as ReactComponent };